<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Generowanie'" [name]="'Generowanie'"></app-breadcrumb>
<div class="commission-job-list-container" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="column" [formGroup]="actionForm">
    <div fxLayoutGap="15px" fxLayout="row">
      <app-month-picker
        class="commission-job-list-filter"
        label="Miesiąc rozliczeniowy" [required]="true"
        [control]="billingMonthControl"
      ></app-month-picker>

      <app-dict-insurance-companies
        label="TU" class="commission-job-filter"
        [required]="false"
        [control]="insuranceCompanyControl"
        (selectedInsuranceCompany)="insuranceCompanyChanged($event)"
        [hideChildren]="true"
      ></app-dict-insurance-companies>

      <mat-form-field class="commission-job-list-filter-long">
        <mat-label>Plik importu</mat-label>
        <mat-select [formControl]="importControl">
          <ng-container *ngFor="let importItem of (importListSubject | async)?.items">
            <mat-option [value]="importItem.uuid" multiLineOption>
              <h4 mat-line>
                {{ importItem.name }}
                <ng-container *ngIf="importItem.importer">({{ importItem.importer.name }})</ng-container>
              </h4>
              <p mat-line>
                {{ importItem.createdBy?.firstName }} {{ importItem.createdBy?.lastName }}
                , {{ importItem.createdAt | date:'y-MM-dd' }}
              </p>
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxLayoutGap="15px" fxLayout="row">
      <app-dict-ofwcas class="commission-job-list-filter-long" [multiple]="false" label="OFWCA" [control]="ofwcaControl"
                       [contractMandate]="false"></app-dict-ofwcas>
      <app-dict-partners class="commission-job-list-filter-long" [multiple]="false" label="Partner"
                         [control]="partnerControl"></app-dict-partners>
    </div>
    <div fxLayoutGap="15px" fxLayout="row">
      <app-dict class="commission-job-list-filter-long" label="Akcja"
                [formControl]="actionControl"
                dictType="commission_job"
                [required]="true"
                (selectedDict)="actionKeyControl.setValue($event.key)"
      ></app-dict>


      <!--        <app-dict-->
      <!--          class="commission-job-filter"-->
      <!--          [label]="'Strona umowy'" [dictType]="'contract_owner'"-->
      <!--          [control]="ownerControl"-->
      <!--          [required]="false"-->
      <!--          [multiple]="false"-->
      <!--        ></app-dict>-->
      <mat-form-field class="commission-job-filter">
        <mat-label>Przepięcie OFWCA</mat-label>
        <mat-select [formControl]="overvoltageControl">
          <mat-option [value]="null">Wszyscy</mat-option>
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="commission-job-filter">
        <mat-label class="p-0">Generowanie rozliczeń</mat-label>
        <mat-select [formControl]="toGenerateControl">
          <mat-option [value]="true">Do wygenerowania</mat-option>
          <mat-option [value]="false">Wszyscy</mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        (click)="make()" mat-raised-button
        [disabled]="!actionForm.valid"
        color="primary">
        <mat-icon>play_arrow</mat-icon>
        <span> Uruchom</span></button>
      <span fxFlex></span>
      <button (click)="checkSettlement()"  mat-stroked-button><span> Zweryfikuj rozliczenia</span></button>
    </div>
  </div>

  <mat-divider></mat-divider>
  <ng-container *ngIf="userPermissions | async as permissions">
    <div
      class="commission-redirection-lock"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="15px"
    >
      <mat-slide-toggle
        color="warn"
        [formControl]="commissionRedirectionLockControl"
        [disabled]="
        commissionRedirectionLockLoading
        || commissionRedirectionLockUpdating
        || !permissions.settlement?.admin_root
      "
        (change)="updateCommissionRedirectionLock($event)"
      >
        Blokada przepięć polis
      </mat-slide-toggle>
      <span *ngIf="commissionRedirectionLockLoading || commissionRedirectionLockUpdating"> Ładowanie...</span>
      <span *ngIf="!commissionRedirectionLockLoading  && !commissionRedirectionLockUpdating && commissionRedirectionLock.active">Aktywna dla miesiąca <strong>{{ commissionRedirectionLock.billingMonth }}</strong>. Automatyczne wyłączenie po wgraniu pliku za <strong>{{ commissionRedirectionLock.unlockBillingMonth }}</strong>.</span>
      <span *ngIf="!commissionRedirectionLockLoading && !commissionRedirectionLockUpdating && !commissionRedirectionLock.active">Blokada jest wyłączona.</span>
    </div>
  </ng-container>

  <mat-divider></mat-divider>

  <div fxLayout="column">
    <table mat-table [dataSource]="jobs" [trackBy]="trackTask">
      <ng-container matColumnDef="billingMonth">
        <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy</th>
        <td mat-cell *matCellDef="let element">
          {{ element.billingMonth }}
        </td>
      </ng-container>

      <ng-container matColumnDef="parameters">
        <th mat-header-cell *matHeaderCellDef> Parametry</th>
        <td mat-cell *matCellDef="let element">
          <div fxLayout="column" fxLayoutGap="0">
            <div *ngIf="element.insuranceCompany">
              <a *ngIf="element.insuranceCompany" class="default-link"
                 [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
                {{ element.insuranceCompany.name }}
                <span *ngIf="element.commissionImport?.importer">
                ({{ element.commissionImport?.importer?.name }})
              </span>
              </a>
            </div>
            <div *ngIf="element.commissionImport">
              {{ element.commissionImport.name }}, {{ element.commissionImport?.totalRows }}
              wierszy, {{ element.commissionImport?.createdAt | date:'y-MM-dd' }}
            </div>
            <div *ngIf="element.ofwca">
              OFWCA: <a class="default-link"
                        [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{ element.ofwca.fullName }}</a>
            </div>
            <div *ngIf="element.partner">
              Partner: <a class="default-link"
                          [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{ element.partner?.shortName }}</a>
            </div>
            <ng-container *ngIf="element.owner">
              Strona umowy: <a class="default-link"> {{ element.owner?.name }}</a>
            </ng-container>
            <ng-container *ngIf="element.overvoltage == '1'">
              <span style="white-space: nowrap;">Przepięcie OFWCA: <a class="default-link">Tak</a></span>
            </ng-container>
            <ng-container *ngIf="element.overvoltage == '0'">
              <span style="white-space: nowrap;">Przepięcie OFWCA: <a class="default-link"> Nie</a></span>
            </ng-container>
            <ng-container *ngIf="element.toGenerate">
              <span>Rozliczenia: <a class="default-link"> Do&nbsp;wygenerowania</a></span>
            </ng-container>
            <div *ngIf="element.owner">
              Strona umowy: <a class="default-link"> {{ element.owner?.name }}</a>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Akcja</th>
        <td mat-cell *matCellDef="let element">
          {{ element.action?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
        <td mat-cell *matCellDef="let element">
          {{ element.requestedAt | date:'y-MM-dd HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.calledBy">
            <div class="circular-image">
              <img class="circular-image small-avatar job-list-avatar"
                   [src]="'/rest/sso/api/user/' + element.calledBy.uuid + '/avatar'" (error)="onImgError($event)"
                   alt="Zdjęcie"/>
            </div>
            <a class="default-link"
               [routerLink]="['/uzytkownicy/szczegoly', element.calledBy.uuid]">{{ element.calledBy.firstName }} {{ element.calledBy.lastName }}</a>
          </ng-container>
          <ng-container *ngIf="!element.calledBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef> Wynik</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.result?.length > 0">
            <ng-container *ngFor="let item of element.result">
              <span>{{ item.key }}: {{ item.value }}</span><br>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{ element.status.name }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            *ngIf="element.action?.key !== COMMISSION_JOB_CLOSE_MONTH && element.action?.key !== COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS && (element.action?.key === COMMISSION_JOB_GENERATE_SETTLEMENTS && ( element.status.key === COMMISSION_JOB_STATUS_PENDING || element.status.key === COMMISSION_JOB_STATUS_IN_ERROR) && (userPermissions | async).settlement.admin_root) "
            mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button
            *ngIf="element.action?.key === COMMISSION_JOB_CLOSE_MONTH || element.action?.key === COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS || (element.action?.key === COMMISSION_JOB_GENERATE_SETTLEMENTS && ( element.status.key !== COMMISSION_JOB_STATUS_PENDING && element.status.key !== COMMISSION_JOB_STATUS_IN_ERROR) || !(userPermissions | async).settlement.admin_root)"
            mat-icon-button>
            <mat-icon>expand_more</mat-icon>
          </button>
          <button *ngIf="element.action?.key === COMMISSION_JOB_GENERATE_INVOICES" mat-icon-button
                  [matMenuTriggerFor]="menu">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button *ngIf="element.action?.key === COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS" mat-icon-button
                  [matMenuTriggerFor]="menu">
            <mat-icon>expand_more</mat-icon>
          </button>

          <mat-menu #menu="matMenu" xPosition="before">
            <!--            <button *ngIf="!element.fileLocation && element.action?.key === COMMISSION_JOB_GENERATE_SETTLEMENTS"  [disabled]="element.fileName || element.status.key === COMMISSION_JOB_STATUS_IN_PROGRESS || element.status.key === COMMISSION_JOB_STATUS_PENDING || element.action?.key !== COMMISSION_JOB_GENERATE_SETTLEMENTS" mat-menu-item (click)="generateReportFile(element, '')">Generuj raport</button>-->
            <!--            <button *ngIf="element.fileLocation && (userPermissions | async).settlement.read_report" mat-menu-item (click)="downloadReportFile(element)">Pobierz raport</button>-->

            <!--            <button mat-menu-item (click)="downloadReportFile(element, COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID)">Pobierz raport - polisy przypisane</button>-->
            <!--            <button mat-menu-item (click)="downloadReportFile(element, COMMISSION_IMPORT_ROW_STATUS_SETTLED_ID)">Pobierz raport - polisy rozliczone</button>-->
            <ng-container *ngIf="element.action?.key === COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS">
                        <button mat-menu-item
                                (click)="downloadGroupedCommissionStatementsPdf(element)"
                        >Pobierz zestawienie</button>
            </ng-container>
            <button
              *ngIf="element.status?.key !== COMMISSION_JOB_STATUS_IN_SUCCESS && element.action?.key !== COMMISSION_JOB_GENERATE_INVOICES && (userPermissions | async).settlement.admin_root"
              [disabled]="!(userPermissions | async).settlement.admin_root" mat-menu-item (click)="deleteJob(element)">
              Usuń
            </button>
            <button *ngIf="element.action?.key === COMMISSION_JOB_GENERATE_INVOICES"
                    [disabled]="element.status?.key !== COMMISSION_JOB_STATUS_IN_SUCCESS" mat-menu-item
                    (click)="zipDownload(element)">Pobierz faktury
            </button>
            <button
              *ngIf="element.status?.key === COMMISSION_JOB_STATUS_IN_SUCCESS && element.action?.key === COMMISSION_JOB_GENERATE_INVOICES && (userPermissions | async).settlement.admin_root"
              [disabled]="!(userPermissions | async).settlement.admin_root" mat-menu-item
              (click)="deleteInvoice(element)">Usuń faktury
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
